import { render, staticRenderFns } from "./FormExamQuestion.vue?vue&type=template&id=f7a14712&"
import script from "./FormExamQuestion.vue?vue&type=script&lang=js&"
export * from "./FormExamQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports